import React from "react";
import Footer from "../../components/Footer";
import Bachelors from "../../components/Bachelors";
import NavBar from "../../components/navbar/NavBar";

const BachelorsPage = () => {
  return (
    <div>
      <NavBar />
      <Bachelors />
      <Footer />
    </div>
  );
};

export default BachelorsPage;
